/**
 * Created by Florin David on 31/07/2017.
 */
import { State } from 'reducers'
import version from './version'
import translations from './translations'
import localStorage from './local-storage'
import { InitialState } from 'initialState'

/**
 * Initial state for redux
 */
export default (
  localState: State = (localStorage.get('state') || {}) as State,
): InitialState => {
  // Florin David: we should consider adding an action OVERWRITE_DEFAULTS and let every reducer to handle the default
  return {
    // syncingData: undefined, // no syncing when app is loaded
    error: undefined, // remove generic error
    version: version, // reset the version
    update: {
      updateInProgress: false,
      updateReady: false,
    },
    intl: {
      ...(localState.intl?.locale
        ? localState.intl
        : translations[localState.intl?.locale || 'en']),
      // always start with fetchingMessages true to avoid double rendering
      fetchingMessages: true,
    },
    // Preserve auth state from localStorage when resetting
    auth: localState.auth?.token
      ? { ...localState.auth, isLoggingIn: false }
      : undefined,
  }
}
